import { call, put, race, select, take } from 'redux-saga/effects';
import { RT } from '../../../../shared/types';

import { commentsModel } from '../';
import { collaborationApi } from '../../../../shared/api';
import { teamsModel } from '../../../teams';
import { CommentsFlow } from '../types';
import { createNotification, snackbarModel } from '../../../snackbar';

export function* createCommentFlow({
  payload: { onCreate, onError, onCancel },
}: ReturnType<typeof commentsModel.actions.startCommentingFlow>) {
  yield put(commentsModel.actions.setCommentsFlow(CommentsFlow.Create));

  const { cancel, create } = yield race({
    cancel: take(commentsModel.actions.endCommentingFlow),
    create: take(commentsModel.actions.createCommentThread),
  });

  if (cancel) {
    yield put(commentsModel.actions.setCommentsFlow(null));
    onCancel();
    return;
  }

  const { payload } = create;
  const currentTeam: RT<
    typeof teamsModel.selectors.selectCurrentTeamWithError
  > = yield select(teamsModel.selectors.selectCurrentTeamWithError);

  try {
    const { threadId }: RT<typeof collaborationApi.createCommentThread> =
      yield call(collaborationApi.createCommentThread, {
        ...payload,
        teamId: currentTeam.id,
      });

    yield put(commentsModel.actions.setCommentsFlow(null));
    onCreate(threadId);
  } catch (error) {
    snackbarModel.actions.addNotificationAction(
      createNotification('error', 'Failed to create a comment')
    );
    onError(error);
  } finally {
    yield put(commentsModel.actions.setIsCommentCreating(false));
  }
}
